import React, { useState } from "react";
// React Bootstrap
import { Navbar, Image, Form, FormControl } from "react-bootstrap";
// Components
import GenericExplorer from "../generic/GenericExplorer";
import ComunidadTarjeta from "./ComunidadTarjeta";
import ComunidadAddTarjeta from "./ComunidadAddTarjeta";
// Styled Components
import styled from "styled-components";
import { InputGroup } from "react-bootstrap";
import TooltipIcon from "../generic/TooltipIcon";

const CustomNavBar = styled(Navbar)`
  /* padding: 0px;
  margin: 0px; */
  min-width: 200px;
`;

const Comunidades = ({ ...props }) => {
  // TODO quitar coger los parametro asi ponerlo en el root
  const idProvincia = props.computedMatch.params.id_p;

  const [search, setSearch] = useState("");
  const [todasComunidades, setTodasComunidades] = useState(false);
  const handleChangeSearch = (e) => {
    setSearch(e.target.value);
  };
  // A partir de los valores de los filtros obtiene el query string
  const getQueryString = () => {
    let count = "20";
    let findName = search ? search : "";

    return `?count=${count}&findName=${findName}`;
  };

  const handleChangeTodasComunidades = () => {
    setTodasComunidades(!todasComunidades);
  };

  return (
    <>
      <h2>Comunidades</h2>
      <GenericExplorer url={todasComunidades ? `/provincias/${idProvincia}/comunidades${getQueryString()}&todasComunidades=true` : `/provincias/${idProvincia}/comunidades${getQueryString()}`} 
      ItemCard={ComunidadTarjeta} 
      ItemAddCard={ComunidadAddTarjeta}
      userLevel={props.userLevel}
      >
        <CustomNavBar expand="md">
          {/* Cuando se hace pequeña la pantalla */}
          <Navbar.Toggle aria-controls="Filtro Comunidades" className="bg-light mb-3">
            <Image className="align-text-top" alt="" height="20" />
            <span className="align-text-bottom"> Filtros</span>
          </Navbar.Toggle>
          {/*          */}
          <Navbar.Collapse className="mb-3" id="basic-navbar-nav">
            <Form as="div" inline className="w-100">
              <FormControl type="text" onChange={handleChangeSearch} placeholder={"Búsqueda"} className="mr-3" />
              <InputGroup className="mt-2">
                <Form.Group>
                  <Form.Check type="checkbox" label={`Todas las comunidades de la provincia`} defaultChecked={todasComunidades} value={todasComunidades} onClick={handleChangeTodasComunidades} />
                  <TooltipIcon className={"ml-1 pb-1"} content={`Al seleccionar esta opción se muestran todas las comunidades de la provincia incluídas las que ha sido suprimidas`} />
                </Form.Group>
              </InputGroup>
            </Form>
          </Navbar.Collapse>
        </CustomNavBar>
      </GenericExplorer>
    </>
  );
};

export default Comunidades;
